import React, { useEffect, useState } from "react";
import logo from "../assets/img/logoadutem.png";
import logoblanco from "../assets/img/logoADUTEMblanco.png";
import "../assets/css/styles.css";
import axios from "../api/axios";

const Convenios = () => {
  const [convenios, setConvenios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Estados para el modal de detalles
  const [modalAbierto, setModalAbierto] = useState(false);
  const [convenioSeleccionado, setConvenioSeleccionado] = useState(null);

  const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    return {
      "Content-Type": "application/json",
      Authorization: token ? `Bearer ${token}` : "",
    };
  };
useEffect(() => {
  const cargarConvenios = async () => {
    try {
      const res = await axios.get("/convenios-inicio", {
        headers: getAuthHeaders(),
      });

      setConvenios(
        (res.data.convenios || []).filter(
          (convenio) => convenio.estado === "activo"
        )
      );
    } catch (err) {
      console.error("Error:", err);
      if (err.response?.status === 401) {
        setError("No autorizado");
      } else {
        setError(err.response?.data?.message || "Error al cargar los convenios");
      }
    } finally {
      setLoading(false);
    }
  };

  cargarConvenios();
}, []);

  // Función para abrir el modal con los detalles
  const verDetalles = (convenio) => {
    setConvenioSeleccionado(convenio);
    setModalAbierto(true);
  };

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando convenios...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container py-5 text-center">
        <div className="alert alert-danger">
          No se pudieron cargar los convenios: {error}
        </div>
      </div>
    );
  }

  return (
    <>
      {/* ================= NAVBAR ================= */}
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container">
          <a className="navbar-brand" href="/">
            <img
              src={logo}
              alt="Logo ADUTEM"
              height="90"
              className="logo-adutem"
            />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarMenu"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarMenu">
            <ul className="navbar-nav ms-auto align-items-center">
              <li className="nav-item me-lg-5">
                <a className="nav-link" href="/">Inicio</a>
              </li>
              <li className="nav-item me-lg-5">
                <a className="nav-link" href="/nosotros">Nosotros</a>
              </li>
              <li className="nav-item me-lg-5">
                <a className="nav-link" href="/convenios">Convenios</a>
              </li>
              <li className="nav-item me-lg-5">
                <a className="nav-link" href="/eventos">Eventos</a>
              </li>
              <li className="nav-item me-lg-5">
                <a className="nav-link" href="/login">Login</a>
              </li>
              <li className="nav-item">
                <a className="btn btn-socio px-4 py-2 rounded-1" href="/sersocio">
                  Ser Socio
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* ================= LISTA DE CONVENIOS ================= */}
      <section className="py-5" style={{ backgroundColor: "#f0f7f0" }}>
        <div className="container">
          <h2 className="fw-bold text-center text-verde-oscuro mb-5">
            Nuestros Convenios
          </h2>

          {convenios.length === 0 ? (
            <div className="text-center py-5">
              <p className="text-muted fs-5">
                Aún no hay convenios registrados
              </p>
            </div>
          ) : (
            <div className="row g-5 justify-content-center">
              {convenios.map((conv) => (
                <div className="col-md-6 col-lg-4" key={conv.id}>
                  <div className="card h-100 shadow-sm border-0 text-center p-4 bg-white">
                    <img
                      src={conv.logo || "https://via.placeholder.com/140?text=Logo"}
                      alt=""
                      className="rounded-circle mx-auto mb-4 border border-4 border-white shadow"
                      width="140"
                      height="140"
                      style={{ objectFit: "contain", backgroundColor: "#f8f9fa" }}
                      onError={(e) => {
                        e.target.src = "https://via.placeholder.com/140?text=Sin+Logo";
                      }}
                    />
                    <h4 className="fw-bold text-verde-oscuro mb-3">
                      {conv.nombre}
                    </h4>
                    <p className="text-success fs-5 fw-medium mt-2 mb-4 px-3" style={{ lineHeight: "1.5" }}>
                      {conv.descripcion || "Sin descripción disponible"}
                    </p>

                   {/* Botón para ver detalles (solo aparece si hay detalles) */}
{conv.detalles && conv.detalles.trim() !== "" && (
  <button
    className="btn btn-success btn-sm mt-2 px-4 fw-semibold shadow-sm rounded-pill"
    onClick={() => verDetalles(conv)}
  >
    Ver detalles <i className="bi bi-chevron-right ms-1"></i>
  </button>
)}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* ================= MODAL DE DETALLES ================= */}
     {/* ================= MODAL DE DETALLES ================= */}{/* ================= MODAL DE DETALLES ================= */}
     {/* ================= MODAL DE DETALLES ================= */}
{modalAbierto && convenioSeleccionado && (
  <div 
    className="modal fade show d-block" 
    tabIndex="-1" 
    style={{ backgroundColor: "rgba(0,0,0,0.6)" }}
    onClick={() => setModalAbierto(false)}   // ← Cierra al hacer clic afuera
  >
    <div 
      className="modal-dialog modal-dialog-centered modal-lg"
      onClick={(e) => e.stopPropagation()}   // ← Evita que se cierre al clicar dentro
    >
      <div className="modal-content rounded-4 shadow border-0">
        
        {/* Header */}
        <div className="modal-header border-0 pb-2 d-flex justify-content-center align-items-center position-relative">
          <h5 className="modal-title fw-bold text-verde-oscuro m-0">
            {convenioSeleccionado.nombre}
          </h5>
          <button 
            type="button" 
            className="btn-close position-absolute top-0 end-0 mt-3 me-3" 
            onClick={() => setModalAbierto(false)}
          ></button>
        </div>

        {/* Body */}
        <div className="modal-body px-5 pb-5 text-center">
          {convenioSeleccionado.logo && (
            <div className="mb-5">
              <img 
                src={convenioSeleccionado.logo} 
                alt=""
                className="rounded shadow mx-auto d-block" 
                style={{ 
                  maxHeight: "160px", 
                  maxWidth: "90%", 
                  objectFit: "contain" 
                }} 
              />
            </div>
          )}

          <h6 className="fw-bold mb-4 text-verde-oscuro">
            Detalles del beneficio
          </h6>

          <div 
            className="mx-auto"
            style={{ 
              maxWidth: "720px",
              lineHeight: "1.8",
              fontSize: "1.05rem",
              whiteSpace: "pre-line"
            }}
          >
            {convenioSeleccionado.detalles
              ? convenioSeleccionado.detalles.split('\n').map((linea, index) => (
                  <p key={index} className="mb-3">{linea.trim()}</p>
                ))
              : <p className="text-muted fst-italic mb-0">Sin detalles disponibles</p>
            }
          </div>
        </div>
        
      </div>
    </div>
  </div>
)}
      {/* ================= FOOTER COMPACTO ================= */}
      <footer className="bg-verde-oscuro text-white py-4">
        <div className="container">
          <div className="row align-items-center gy-4">
            <div className="col-lg-4 text-center text-lg-start">
              <img
                src={logoblanco}
                alt="Logo ADUTEM"
                height="60"
                className="me-3 mb-2"
              />
              <p className="mb-0 small opacity-80">
                Asociación de Docentes de la Universidad Técnica de Manabí
              </p>
            </div>

            <div className="col-lg-4 text-center">
              <h6 className="fw-bold mb-2 small text-uppercase">Dirección</h6>
              <p className="mb-1 small opacity-90">
                <i className="bi bi-geo-alt me-2"></i>
                Calle: Chile y Los Amigos
              </p>
              <p className="mb-1 small opacity-90">
                <i className="bi bi-telephone me-2"></i>
                Teléfono: (05) 2632-200 / 0999162353
              </p>
              <p className="mb-3 small opacity-90">
                <i className="bi bi-envelope me-2"></i>
                adutem@utm.edu.ec
              </p>

              <h6 className="fw-bold mb-3 small text-uppercase">Redes Sociales</h6>
              <div className="d-flex justify-content-center gap-4">
                <a href="https://www.instagram.com/adutem2025?igsh=MWU2aXJhZnh1Zjhtag==" className="text-white fs-4 opacity-80"><i className="bi bi-instagram"></i></a>
                <a href="https://www.facebook.com/share/1EQhuaFzqH/?mibextid=wwXIfr" className="text-white fs-4 opacity-80"><i className="bi bi-facebook"></i></a>
                <a href="https://youtube.com/@adutem?si=dluaO2vDTwiUwyfh" className="text-white fs-4 opacity-80"><i className="bi bi-youtube"></i></a>
              </div>
            </div>

            <div className="col-lg-4"></div>
          </div>

          <div className="text-center mt-3 pt-3 border-top border-secondary border-opacity-50">
            <small className="opacity-70">
              ADUTEM 2022 - 2025 © Todos los derechos reservados
            </small>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Convenios;